<template>
  <ChatThreadView
    v-if="activeDMThreadId"
    :key="activeDMThreadId"
    :thread-id="activeDMThreadId"
    @back="openDMThread(null)"
  />
  <div v-else class="flex flex-col h-full min-h-0">
    <div class="px-3 py-2 border-b border-white/5 flex items-center justify-between">
      <span class="text-[10px] uppercase tracking-widest text-text-muted font-semibold">
        Unread
      </span>
      <span v-if="totalUnread > 0" class="text-[10px] text-text-dim tabular-nums">
        {{ totalUnread }} {{ totalUnread === 1 ? 'message' : 'messages' }}
      </span>
    </div>

    <div class="flex-1 overflow-y-auto scrollbar-thin scrollbar-track-transparent">
      <div v-if="loading && unreadThreads.length === 0" class="flex justify-center py-8">
        <div class="w-6 h-6 border-2 border-white/10 border-t-primary rounded-full animate-spin"></div>
      </div>

      <div v-else-if="unreadThreads.length === 0" class="text-center py-12 px-4">
        <p class="text-sm text-text-muted">Inbox zero</p>
        <p class="text-[11px] text-text-dim mt-1">No unread messages.</p>
      </div>

      <ChatThreadRow
        v-for="t in unreadThreads"
        :key="t.id"
        :thread="t"
        @click="openDMThread(t.id)"
      />
    </div>
  </div>
</template>

<script setup>
import { useChatInbox } from '~/composables/chat/useChatInbox'
import { useChatUI } from '~/composables/chat/useChatUI'

const { totalUnread, unreadThreads, loading } = useChatInbox()
const { activeDMThreadId, openDMThread } = useChatUI()
</script>
